export default function sortRecords({name: oneName, sort_index: oneSortIndex}, {name: otherName, sort_index: otherSortIndex}) {
    if (Number.isFinite(oneSortIndex) && Number.isFinite(otherSortIndex)) {
        return oneSortIndex - otherSortIndex;
    }

    return String(oneName || '').localeCompare(String(otherName || ''));
}
